import { types } from "../types/types";

const initial = {
  asistenciasIDs: [],
  propuestas: [],
};

export const propuestasReducer = (state = initial, action) => {
  switch (action.type) {
    case types.storePropuestas:
      return {
        ...state,
        asistenciasIDs: action.payload.asistencias,
        propuestas: action.payload.propuestas,
      };

    default:
      return state;
  }
};
